<template>
    <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
      <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="activePrompt = true" />
      <!-- <router-link :to="`/invoices/transactions/view/${params.value}`"><feather-icon icon="EyeIcon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" /></router-link> -->
      <div>
        <vs-prompt
            @cancel="cname = ''"
            @accept="updatec"
            @close="close"
            :title="`Edit Category`"
            :is-valid="validName"
            :active.sync="activePrompt">
            <div class="con-exemple-prompt">
              <vs-input placeholder="Name" v-model="cname" class="mt-4 mb-2 w-full" />
            </div>
        </vs-prompt>
      </div>
    </div>
</template>

<script>
    export default {
        name: 'CellRendererActions',
        data(){
          return {
            activePrompt: false,
            cname: "",
          }
        },
        mounted(){
          this.cname = this.params.data.name
        },
        computed:{
          validName(){
            return (this.cname.length > 0)
          }
        },
        methods: {
          updatec(){

            let local_data = { name: this.cname, id: this.params.data.id }

            this.$store.dispatch("categoryManagement/updateCategoryThematic" , local_data )
            .then( () => {
                this.$vs.notify({
                  color:'success',
                  title:'Category updated',
                  text:'category updation successful'
                })
            })
            .catch( err => {

              this.$vs.notify({
                color:'danger',
                title:'Error',
                text: err.response.data.msg
              })
            })
          },
          close(){

          }
        }
    }
</script>
